var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#83858c;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st1{fill:#83858c;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16,
    r: 2.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,22.75c-4.43,0-8.43-2.46-10.46-6.41L5.37,16l0.18-0.34C7.57,11.71,11.57,9.25,16,9.25 s8.43,2.46,10.46,6.41L26.63,16l-0.17,0.34C24.43,20.29,20.43,22.75,16,22.75z M7.06,16c1.82,3.25,5.21,5.25,8.94,5.25 c3.73,0,7.12-2,8.94-5.25c-1.82-3.25-5.21-5.25-8.94-5.25C12.27,10.75,8.88,12.75,7.06,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccv);
export default __webpack_public_path__ + "static/media/accv.84984bfc188a8b5e3641dec66d663415.svg";
export { ForwardRef as ReactComponent };